/**
 * Marketing Attribution Collector
 *
 * Google Ads / paid-social landings arrive with ?gclid=… and/or
 * ?utm_source=…&utm_medium=…&utm_campaign=…. By the time the shopper opens the
 * configurator (fullscreen overlay, ?step=2 via pushState) and submits the
 * save-design form — minutes and navigations later — those query params are
 * long gone. So this script captures them at landing and stashes them in
 * localStorage, where the configurator bundle reads them back at save time
 * and includes them in the save-design POST's customerData
 * (see src/configurator-v2/src/lib/api/savedDesigns.js).
 *
 * Storage semantics (first-touch wins within TTL):
 * - Only keys present in the current URL are written; other stored keys are
 *   preserved. A bare PDP view never wipes attribution.
 * - Entry expires after 90 days (typical ad-attribution window).
 * - First-party functional storage of URL params the shopper arrived with;
 *   no third-party cookie, no cross-site tracking.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'sh_marketing_attribution_v1';
  var TTL_MS = 90 * 24 * 60 * 60 * 1000; // 90 days
  var MAX_LEN = 255;
  var PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'gclid'];

  function sanitize(value) {
    if (value == null) return '';
    return String(value).trim().slice(0, MAX_LEN).replace(/[<>"'`]/g, '');
  }

  function readStored() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object' || !parsed.values) return null;
      if (parsed.lastSeenAt && Date.now() - parsed.lastSeenAt > TTL_MS) {
        try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) { /* ignore */ }
        return null;
      }
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function captureFromUrl() {
    var qs;
    try {
      qs = new URLSearchParams(window.location.search);
    } catch (e) {
      return;
    }
    var found = {};
    var hasAny = false;
    for (var i = 0; i < PARAMS.length; i++) {
      var v = sanitize(qs.get(PARAMS[i]));
      if (v) {
        found[PARAMS[i]] = v;
        hasAny = true;
      }
    }
    if (!hasAny) return;

    var prev = readStored() || { values: {}, firstSeenAt: null };
    var merged = {};
    for (var j = 0; j < PARAMS.length; j++) {
      var key = PARAMS[j];
      if (found[key]) {
        merged[key] = found[key];
      } else if (prev.values && prev.values[key]) {
        merged[key] = prev.values[key];
      }
    }

    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
        values: merged,
        firstSeenAt: prev.firstSeenAt || Date.now(),
        lastSeenAt: Date.now(),
        landingUrl: String(window.location.href).slice(0, 512)
      }));
    } catch (e) { /* storage unavailable — attribution simply won't persist */ }
  }

  function get() {
    var stored = readStored();
    return stored && stored.values ? stored.values : {};
  }

  window.MarketingAttribution = {
    get: get,
    params: PARAMS.slice(),
    storageKey: STORAGE_KEY
  };

  captureFromUrl();
})();
